import { isFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-17956: Раздел Документы переезд с метода api/v2/feed на api/v4/private/feed
export const IS_ALL_DOC_FEED_V4_ENABLED = isFeature('is-alldocuments-feed-v4-enabled');
